<template>
  <div v-if="storedCustomer && apiUser && apiUser.isCustomerAdmin" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("spravaUzivatelu") }}
          </h2>
          {{ $t("proZakaznika") }} {{ storedCustomer.customerName }}
        </div>
        <div class="d-flex gap-2 align-items-center">
          <input
            id="guisearch"
            ref="searchInput"
            v-model="search"
            type="text"
            :placeholder="this.$t('hledat')"
            autofocus
          />
          <div class="btn btn-primary d-flex align-items-center justify-content-center" @click="toggleNewUser('newUser')">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-nova.svg" />
          </div>
          {{ $t("novyUzivatel") }}</div>
        </div>
      </div>
    </form>

    <div class="mt-4">
      <RadioHelp
        :article-link="'/admin/customer/users'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
      <div class="d-flex flex-wrap mt-3 mb-2 position-relative">
        <button
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2 mb-2"
          :disabled="!selectedRows || selectedRows.length == 0"
          @click="toggleAppendModal('appendUser')"
        >
          {{ $t("priraditProjektu") }}
        </button>
        <button
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2"
          :disabled="!selectedRows || selectedRows.length == 0"
          @click="toggleRemoveModal('removeUser')"
        >
          {{ $t("odebratProjektu") }}
        </button>

        <!--
        <div class="d-flex">
          <span class="btn-sm d-flex align-items-center justify-content-center"
            >{{ $t("Správa osob") }}:</span
          >
          <a
            class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2"
            target="_blank"
            v-bind:href="this.$t('LINK_MOJE_CRA')"
          >
            {{ $t("Moje CRA") }}
          </a>
        </div>
        -->

        <!--button
          v-if="selectedRows"
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
          :disabled="selectedRows.length == 0"
          @click="toggleDeleteUsers(selectedRows)"
        >
          {{ $t("smazatUzivatele") }}
        </button-->
        <RadioOpenClose
          :radio-slides="radioSlides"
          :show="showHelp"
          :custom-class="'d-flex align-items-end radio--default'"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>

      <div v-if="usersWithProjects.length > 0" class="position-relative w-100">
        <div id="users" class="table-responsive">
          <table class="table table-main table-hover">
            <thead>
              <tr>
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :style="{ 'min-width': column.minWidth }"
                  :class="{ isHidden: !column.visible }"
                >
                  <span v-if="column.sortable != true">
                    {{ $t(column.name) }}
                  </span>
                  <span v-else>
                    <div class="title" @click="sortBy(column.sortBy)">
                      {{ $t(column.name) }}
                    </div>
                    <div v-if="sort == column.type" class="sorting">
                      <span v-if="sortType == 'desc'">▼</span>
                      <span v-if="sortType == 'asc'">▲</span>
                    </div>
                  </span>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in filteredUserList.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  v-for="(column, column_index) in columns"
                  :key="column_index"
                  :style="{ width: column.minWidth }"
                  :class="{
                    isHidden: !column.visible
                  }"
                >
                  <span v-if="column.name == 'userId'">
                    <div
                      style="display: inline-block"
                      class="custom-control custom-control--checkbox"
                      :class="{
                        checked: selectedRows.filter((e) => e.userId === item.userId).length > 0
                      }"
                      @click="addToSelected(item)"
                    >
                      <input type="checkbox" class="custom-control-input" />
                    </div>
                    <a @click="openUserDetail(item)">
                      {{ item[column.type] }}
                    </a>
                  </span>
                  <span v-else-if="column.name == 'projects'" v-html="item[column.type].join(',')" />
                  <span v-else>
                    {{ item[column.type] }}
                  </span>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
          <table class="table table-hover fixed-last-column" :class="{ showShadow: showShadow }">
            <thead>
              <tr>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in filteredUserList.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    class="kebab"
                    :class="{
                      opened: openedItem.userId == item.userId
                    }"
                  >
                    <div class="dropdown-actions">
                      <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                        <img src="@/assets/icons/menu/ico-kebab.svg" />
                      </div>
                      <div
                        v-if="openedItem.userId == item.userId"
                        v-click-outside="closeKebabConf"
                        class="dropdown-actions__wrapper"
                      >
                        <div class="dropdown-actions__inner">
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="openUserDetail(openedItem)"
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-zakaznik.svg" />
                            </div>
                            {{ $t("informaceOUzivateli") }}
                          </div>
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="editUserDetail(openedItem)"
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-zakaznik.svg" />
                            </div>
                            {{ $t("zmenitUdaje") }}
                          </div>
                          <div
                            v-if="!openedItem.notSelectable"
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="addToProject()"
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-projekt.svg" />
                            </div>
                            {{ $t("priraditProjektu") }}
                          </div>
                          <div
                            v-if="!openedItem.notSelectable"
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="removeFromProject()"
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-projekt.svg" />
                            </div>
                            {{ $t("odebratProjektu") }}
                          </div>
                          <div class="dropdown-actions__item d-flex align-items-center" @click="confirmDeleteUser()">
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
                            </div>
                            {{ $t("deleteUser") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="usersWithProjects.length > 0"
        class="custom-table__footer d-flex align-items-center justify-content-between"
      >
        <div class="custom-table__footer__actions align-items-center" />

        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: usersWithProjects.length,
            itemsCount: usersWithProjects.length
          }"
          @next-page="page++"
          @page="page = $event"
          @prev-page="page--"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>
    </div>
    <div v-if="openedDetail.length > 0">
      <UsersDetail
        :user="selectedUser"
        :opened="openedDetail"
        @open-box="toggleDetailModal"
        @close-box="toggleDetailModal"
      />
    </div>
    <div v-if="openedEditDetail.length > 0">
      <UsersEditDetail
        :user="selectedUser"
        :opened="openedEditDetail"
        @open-box="toggleEditModal"
        @close-box="toggleEditModal"
      />
    </div>
    <div v-if="openedAppend.length > 0">
      <AppendToProject
        :users="selectedRows"
        :opened="openedAppend"
        @open-box="toggleAppendModal"
        @close-box="toggleAppendModal"
      />
    </div>
    <div v-if="openedRemove.length > 0">
      <RemoveFromProject
        :users="selectedRows"
        :opened="openedRemove"
        @open-box="toggleRemoveModal"
        @close-box="toggleRemoveModal"
      />
    </div>
    <div v-if="openedNewUser.length > 0">
      <UsersNew :opened="openedNewUser" @open-box="toggleNewUser" @close-box="toggleNewUser" />
    </div>
    <DeleteUsersModal
      v-if="selectedRows"
      :opened="openedDeleteUser"
      :items="selectedRows"
      :text="deleteText"
      :centered="true"
      @yes="
        () => {
          deleteUsers()
          toggleDeleteUsers(selectedRows)
        }
      "
      @close="toggleDeleteUsers()"
    />
    <DeleteUserModal
      v-if="showModalDeleteSingleUser"
      :opened="modalOpenedDeleteUser"
      :items="usersToDelete"
      :text="deleteText"
      :title="$t('confirmUserDelete') + ' ' + storedCustomer.customerName"
      :centered="true"
      @yes="confirmedDeleteUser"
      @close="closeDeleteUser"
    />

    <InfoConfirmationModal
      :opened="openedInfoConfirmation"
      :text="'requestReceived202'"
      @yes="closeBox('editUser')"
      @no="closeBox('editUser')"
      @close="toggleConfirmation"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false" />
    </div>
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import UsersDetail from "@/components/modals/admin/customer/user.vue"
import UsersNew from "@/components/modals/admin/customer/userNew.vue"
import UsersEdit from "@/components/modals/admin/customer/userEdit.vue"
import AppendToProject from "@/components/modals/admin/customer/appendUser.vue"
import RemoveFromProject from "@/components/modals/admin/customer/removeUser.vue"
import DeleteUsersModal from "@/components/confirmations/delete.vue"
import DeleteUserModal from "@/components/confirmations/deleteUser.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import InfoConfirmationModal from "@/components/confirmations/info.vue"
import Paging from "@/components/paging/paging.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    Paging,
    DeleteUsersModal,
    RadioHelp,
    RadioOpenClose,
    UsersDetail,
    UsersEditDetail: UsersEdit,
    UsersNew,
    AppendToProject,
    RemoveFromProject,
    ErrorModal,
    InfoConfirmationModal,
    DeleteUserModal
  },
  setup() {
    const authStore = useAuthStore()
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return { authStore, customerStore, projectStore, configStore }
  },
  data() {
    return {
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      rowsPerPage: 20,
      page: 0,
      radioSlides: [],
      showHelp: true,
      loading: false,
      users: [],
      openedItem: {},
      selectedRows: [],
      search: "",
      openedDetail: [],
      openedEditDetail: [],
      selectedUser: {},
      openedAppend: [],
      openedRemove: [],
      customerUsers: [],
      openedNewUser: [],
      usersWithProjects: [],
      openedDeleteUser: false,
      deleteText: "",
      errorsToTranslate: [],
      openedError: false,
      showModalDeleteSingleUser: false,
      modalOpenedDeleteUser: false,
      usersToDelete: [],
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      openedInfoConfirmation: false,
      sort: "userId",
      sortType: "asc",
      columns: [
        {
          type: "userId",
          name: "userId",
          sortable: true,
          sortBy: "userId",
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "firstName",
          name: "firstName",
          sortable: true,
          sortBy: "firstName",
          visible: true,
          order: 2,
          minWidth: "50px"
        },
        {
          type: "lastName",
          name: "lastName",
          sortable: true,
          sortBy: "lastName",
          visible: true,
          order: 3,
          minWidth: "50px"
        },
        {
          type: "phone",
          name: "phone",
          sortable: true,
          sortBy: "phone",
          visible: true,
          order: 4,
          minWidth: "170px"
        },
        {
          type: "email",
          name: "email",
          sortable: true,
          sortBy: "email",
          visible: true,
          order: 5,
          minWidth: "250px"
        },
        {
          type: "projects",
          name: "projects",
          sortBy: "projects",
          sortable: false,
          visible: true,
          order: 6,
          minWidth: "50px"
        },
        {
          type: "role",
          name: "role",
          sortable: true,
          sortBy: "role",
          visible: true,
          order: 7,
          minWidth: "160px"
        }
      ],
      tableColumnsDefault: {
        userId: {
          show: true,
          order: 1,
          title: "userId"
        },
        firstName: {
          show: true,
          order: 2,
          title: "firstName"
        },
        lastName: {
          show: true,
          order: 3,
          title: "lastName"
        },
        phone: {
          show: true,
          order: 4,
          title: "phone"
        },
        email: {
          show: true,
          order: 5,
          title: "email"
        }
      }
    }
  },
  computed: {
    apiUser() {
      return this.authStore.apiUser
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    projects() {
      return this.projectStore.projectList
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    filteredUserList() {
      return this.usersWithProjects.filter((user) =>
        Object.values(user).some((val) =>
          typeof val === "string" ? val.toLowerCase().includes(this.search.toLowerCase()) : false
        )
      )
    }
  },
  watch: {
    storedCustomer() {
      this.loadUsers()
    },
    customerUsers() {
      this.loadUsersWithProjects()
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    },
    filteredUserList() {
      this.updateResponsiveTable()
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    if (this.storedCustomer) {
      this.loadUsers()
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
  },
  methods: {
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.usersWithProjects = sorted
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      return event.target.className !== "custom-control-label"
    },
    openKebab(user) {
      this.openedItem = this.openedItem == user ? {} : user
    },
    closeKebab() {
      this.openedItem = {}
    },
    toggleConfirmation() {
      this.openedInfoConfirmation = this.openedInfoConfirmation ? false : true
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "users")
    },
    addToSelected(item) {
      if (this.selectedRows.filter((e) => e.userId === item.userId).length > 0) {
        this.selectedRows = this.selectedRows.filter((i) => i.userId !== item.userId)
      } else {
        this.selectedRows.push(item)
      }
    },
    unselectRows() {
      this.selectedRows = []
    },
    addToProject() {
      this.unselectRows()
      this.selectedRows.push(this.openedItem)
      this.toggleAppendModal("appendUser")
    },
    removeFromProject() {
      this.unselectRows()
      this.selectedRows.push(this.openedItem)

      this.openedRemove.push("removeUser")
    },
    confirmDeleteUser() {
      this.usersToDelete = []
      this.usersToDelete.push(this.openedItem)
      this.showModalDeleteSingleUser = true
      this.modalOpenedDeleteUser = true
    },
    confirmedDeleteUser() {
      this.deleteUser()
      //this.toggleDeleteUsers();
    },
    closeDeleteUser() {
      this.unselectRows()
      this.usersToDelete = []
      this.showModalDeleteSingleUser = false
      this.modalOpenedDeleteUser = false
    },
    deleteUser() {
      // this.openedItem
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      if (!this.openedItem.privileges.some(({ privilege }) => privilege === "CustomerAdmin")) {
        this.$store.commit("modals/setWaitingLoader", this.$t("Mažu uživatele, čekejte prosím..."))

        promises.push(
          axios
            .delete(
              `${process.env.VUE_APP_API}/users/${this.openedItem.userId}/customers/${this.customer.customerId}`,
              {}
            )
            .then((response) => {
              this.$store.commit("modals/setWaitingLoader", "")
              if (response.status == 202) {
                /*
                notifications.push({
                  text: "requestReceived202",
                  error: false
                });
                this.errorsToTranslate.push({
                  errors: [this.$t("requestReceived202")]
                });
                */
                this.openedInfoConfirmation = true
                this.openedError = true
              } else if (response.status == 201) {
                notifications.push({
                  text: "requestProcessed201",
                  error: false
                })
              }
              this.showModalDeleteSingleUser = false
              this.modalOpenedDeleteUser = true
              this.loadUsers()
            })
            .catch((err) => {
              console.log(err, "ERRR")
              this.showModalDeleteSingleUser = false
              this.modalOpenedDeleteUser = true
              this.errorsToTranslate.push(err.data)
            })
        )
      } else {
        this.errorsToTranslate.push({
          errors: [this.$t("IoTSpravce") + " " + this.openedItem.email + " " + this.$t("nelzeSmazat")]
        })
      }

      Promise.all(promises).then(() => {
        this.$store.commit("modals/setWaitingLoader", "")
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true

        this.showModalDeleteSingleUser = false
        this.modalOpenedDeleteUser = false
      })

      this.unselectRows()
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    loadUsers() {
      this.customerUsers = []
      this.users = []

      axios
        .get(process.env.VUE_APP_API + "/users?limit=1&customerId[eq]=" + this.storedCustomer.customerId)
        .then((result) => {
          let query
          let steps = Math.ceil(result.data.metadata.count / 200)
          let promises = []
          for (let i = 0; i < steps; i++) {
            query = "/users?customerId[eq]=" + this.storedCustomer.customerId + "&offset=" + i * 200 + "&limit=200"

            promises.push(
              axios
                .get(process.env.VUE_APP_API + query)
                .then((result) => {
                  this.users = result.data.data
                  console.log("apiresult")
                  console.log(this.users)
                  console.log("afterapiresult")

                  // customerAdmin has all projects, we have to disable checkbox in table
                  result.data.data.forEach((user) => {
                    let isIotAdmin = false
                    /**
                     * let's find whether user is IoTAdmin
                     */
                    user.privileges.forEach((privilege) => {
                      if (privilege.privilege == "IoTAdmin" && privilege.customerId == this.storedCustomer.customerId) {
                        isIotAdmin = true
                      }
                    })
                    if (
                      user.privileges.some(
                        ({ privilege, customerId }) =>
                          privilege === "CustomerAdmin" && customerId == this.storedCustomer.customerId
                      )
                    ) {
                      user.notSelectable = true
                    }
                    /**
                     * IoTAdmins are not shown in table
                     */
                    if (isIotAdmin === false) {
                      this.customerUsers = this.customerUsers.concat([user])
                    }
                  })
                })
                .catch(() => {})
            )
          }
          return Promise.all(promises).then(() => {
            this.$nextTick(() => {
              this.updateResponsiveTable()
            })
            return true
          })
        })
    },
    loadUsersWithProjects() {
      this.loading = true
      console.log("loadUsersWithProjects()")
      console.log(this.customerUsers)
      let users = []
      for (const user of this.customerUsers) {
        let obj = structuredClone(user)
        obj.projects = []
        console.log("adding projects for user")
        console.log(user)
        console.log(this.storedCustomer.customerId)
        let isIotAdmin = false
        user.privileges.forEach((privilege) => {
          if (privilege.privilege == "IoTAdmin" && privilege.customerId == this.storedCustomer.customerId) {
            isIotAdmin = true
          }
        })
        user.privileges.forEach((privilege) => {
          if (
            privilege.privilege == "ProjectAdmin" &&
            privilege.projectId !== "." &&
            privilege.customerId == this.storedCustomer.customerId &&
            isIotAdmin === false
          ) {
            obj.projects.push(privilege.projectId)
            obj.role = "ProjectAdminRole"
          }
        })

        if (
          user.privileges.some(
            ({ privilege, customerId }) => privilege === "ProjectAdmin" && customerId === this.storedCustomer.customerId
          )
        ) {
          obj.role = "ProjectAdminRole"
        }

        // customerAdmin has all projects
        if (
          user.privileges.some(
            ({ privilege, customerId }) =>
              privilege === "CustomerAdmin" && customerId === this.storedCustomer.customerId
          )
        ) {
          obj.projects = []
          obj.projects.push("AllProjects")
          obj.role = "CustomerAdminRole"
        }

        users.push(obj)

        this.loading = false
      }
      this.usersWithProjects = users
    },
    openItem(item) {
      this.openedItem = item
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    toggleRemoveModal(box) {
      if (this.openedRemove.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedRemove = []
          this.loadUsers()
          this.unselectRows()
        } else {
          this.openedRemove.splice(this.openedRemove.indexOf(box), 1)
        }
        if (this.openedRemove.length == 0) {
          this.loadUsers()
          this.unselectRows()
        }
      } else {
        this.openedRemove.push(box)
      }
    },
    toggleAppendModal(box) {
      if (this.openedAppend.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedAppend = []
          this.loadUsers()
          this.unselectRows()
        } else {
          this.openedAppend.splice(this.openedAppend.indexOf(box), 1)
        }
        if (this.openedAppend.length == 0) {
          this.loadUsers()
          this.unselectRows()
        }
      } else {
        this.openedAppend.push(box)
      }
    },
    toggleNewUser(box) {
      if (this.openedNewUser.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedNewUser = []
          //this.loadUsers();
        } else {
          this.openedNewUser.splice(this.openedNewUser.indexOf(box), 1)
        }
        if (this.openedNewUser.length == 0) {
          this.selectedRows = []
          this.loadUsers()
        }
      } else {
        this.openedNewUser.push(box)
      }
    },
    toggleDetailModal(box) {
      if (this.openedDetail.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedDetail = []
          this.selectedRows = []
          this.loadUsers()
        } else {
          this.openedDetail.splice(this.openedDetail.indexOf(box), 1)
        }
      } else {
        this.openedDetail.push(box)
      }
    },
    toggleEditModal(box) {
      if (this.openedEditDetail.length > 0) {
        this.openedEditDetail = []
        this.selectedRows = []
        this.loadUsers()
      } else {
        this.openedEditDetail.push(box)
      }

      /*
      if (this.openedEditDetail.indexOf(box) > -1) {
        if (box == undefined) {
          this.openedEditDetail = [];
          this.selectedRows = [];
          this.loadUsers();
        } else {
          this.openedEditDetail.splice(this.openedEditDetail.indexOf(box), 1);
        }
      } else {
        this.openedEditDetail.push(box);
      }
      */
    },
    toggleDeleteUsers(items) {
      if (this.openedDeleteUser == true) {
        this.openedDeleteUser = false
        this.deleteText = ""
      } else {
        if (items) {
          if (items.length == 1) {
            this.deleteText = items[0].email
          } else if (items.length > 1 && items.length < 5) {
            this.deleteText = "uzivatele"
          } else {
            this.deleteText = "uzivatelu"
          }
        }
        this.openedDeleteUser = true
      }
    },
    deleteUsers() {
      let notifications = []
      this.errorsToTranslate = []

      let promises = []
      this.selectedRows.forEach((item) => {
        if (!item.privileges.some(({ privilege }) => privilege === "CustomerAdmin")) {
          promises.push(
            axios
              .delete(`${process.env.VUE_APP_API}/users/${item.email}/customers/${this.customer.customerId}`, {})
              .then((response) => {
                if (response.status == 202) {
                  /*
                  notifications.push({
                    text: "requestReceived202",
                    error: false
                  });
                  */
                  this.openedInfoConfirmation = true
                } else if (response.status == 201) {
                  notifications.push({
                    text: "requestProcessed201",
                    error: false
                  })
                }
                this.loadUsers()
              })
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          )
        } else {
          this.errorsToTranslate.push({
            errors: [this.$t("IoTSpravce") + " " + item.email + " " + this.$t("nelzeSmazat")]
          })
        }
      })
      Promise.all(promises).then(() => {
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true
      })
    },
    openUserDetail(item) {
      this.selectedUser = item
      this.openedDetail.push("userDetail")
    },
    editUserDetail(item) {
      this.selectedUser = item
      this.openedEditDetail.push("userEditDetail")
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
